module.exports = __webpack_public_path__ + "static/media/Position_6.772d3101.jpg";